import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-014eb89c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-6",
  align: "center"
}
const _hoisted_2 = { align: "center" }
const _hoisted_3 = {
  align: "center",
  justify: "space-between"
}
const _hoisted_4 = { style: {"width":"85%"} }

import { useI18n } from "vue-i18n"
import { computed, onBeforeUnmount, ref, watch } from "vue"
import { DoctorProfile, SearchParams, Student } from "@/types"
import HeaderComponent from "../Header/HeaderComponent.vue"
import router from "@/router"
import { onMounted } from "vue"
import { useRoute } from "vue-router"
import { useUserActions } from "@/stores/user-actions"
import moment from "moment"
import GeneralInformation from "../StudentProfile/GeneralInformation/GeneralInformation.vue"
import FooterComponent from "../Footer/FooterComponent.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationComponent',
  setup(__props) {

const userAction = useUserActions()
const { t } = useI18n()
const route = useRoute()
const id = ref()
const startDate = ref<Date | null>(null)
const endDate = ref<Date | null>(null)
const today = ref(new Date())
const token = ref<string | null>(null)
const doctorResponseStatus = ref({})
const isDoctorLoading = ref(true)
const isDoctorAvailable = ref(false)
const isNewDateLoading = ref(false)
const savedSearchParams = ref<SearchParams>()
const doctor = ref<DoctorProfile | undefined>(undefined)
const smallWindow = ref(window.innerWidth < 1000)

onMounted(() => {
  id.value = route.params.id
  token.value = localStorage.getItem("accessToken") ?? null
  if (token.value) {
    localStorage.removeItem("docId")
    getDoctorProfile()
  } else {
    router.push("/login")
  }

  const storedSearchParams = localStorage.getItem("searchParams")
  if (storedSearchParams) {
    savedSearchParams.value = JSON.parse(storedSearchParams)
    startDate.value = savedSearchParams?.value?.startDate
      ? moment(savedSearchParams?.value?.startDate).locale("de").toDate()
      : null

    endDate.value = savedSearchParams?.value?.endDate
      ? moment(savedSearchParams?.value?.endDate).locale("de").toDate()
      : null
  }
})

const updateWindowSize = (): void => {
  smallWindow.value = window.innerWidth < 1000
}

onMounted(() => {
  window.addEventListener("resize", updateWindowSize)
})

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateWindowSize)
})

const doctorName = computed(() => {
  return doctor.value
    ? `${doctor.value.title} ${doctor.value.firstName} ${
        doctor.value.lastName || ""
      }`
    : ""
})
const doctorSpecialty = computed(() => {
  return doctor.value?.specialty ?? ""
})

const doctorAddress = computed(() => {
  return `${doctor.value?.clinicStreet}, ${doctor.value?.clinicLocation}, ${doctor.value?.clinicLand}`
})

async function handleStartDateChange(newDate: Date | null): Promise<void> {
  isNewDateLoading.value = true

  if (newDate) {
    startDate.value = newDate
    endDate.value = new Date(startDate.value)
    endDate.value.setDate(endDate.value.getDate() + 30)
    const response = await userAction.isDoctorAvailable(
      id.value,
      userAction.getDatesInString(startDate.value),
      userAction.getDatesInString(endDate.value)
    )
    isDoctorAvailable.value = response.result?.isAvailable as boolean

    isNewDateLoading.value = false
  }
}

watch(startDate, handleStartDateChange)

const getDoctorProfile = async (): Promise<void> => {
  const response = await userAction.getSingleDoctor(id.value, {})
  doctorResponseStatus.value = response
  if (response.success) {
    doctor.value = response.result as DoctorProfile
  }
  isDoctorLoading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderComponent),
    _createVNode(_component_request_status, {
      class: "mt-6",
      response: doctorResponseStatus.value,
      isLoading: isDoctorLoading.value
    }, null, 8, ["response", "isLoading"]),
    (!isDoctorLoading.value && doctor.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_col, {
            cols: smallWindow.value ? 12 : 8
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    class: "mt-10",
                    justify: "space-between"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        class: _normalizeClass(["mt-1", !smallWindow.value ? 'ml-5' : undefined])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "custom-title" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(doctorName.value), 1)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("p", _hoisted_2, _toDisplayString(doctorSpecialty.value), 1),
                          _createVNode(_component_v_card_subtitle, { class: "mt-2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { icon: "mdi-map-marker" }),
                              _createTextVNode(" " + _toDisplayString(doctorAddress.value), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_subtitle, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_img, {
                                width: "30",
                                style: {"border-radius":"10%"},
                                src: doctor.value.universityLogo
                              }, null, 8, ["src"]),
                              _createTextVNode(_toDisplayString(doctor.value.university), 1)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_VueDatePicker, {
                                class: "mt-3 mb-2",
                                "enable-time-picker": false,
                                modelValue: startDate.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event)),
                                format: "dd MMM yyyy",
                                density: "compact",
                                variant: "outlined",
                                clearable: false,
                                label: _ctx.$t('you-apply'),
                                "min-date": today.value,
                                onChange: handleStartDateChange,
                                placeholder: _ctx.$t('search.date-line')
                              }, null, 8, ["modelValue", "label", "min-date", "placeholder"])
                            ]),
                            (isNewDateLoading.value)
                              ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                  key: 0,
                                  color: "green",
                                  indeterminate: ""
                                }))
                              : _createCommentVNode("", true),
                            (
                  !isDoctorAvailable.value &&
                  startDate.value !== null &&
                  !isNewDateLoading.value &&
                  !isDoctorLoading.value
                )
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 1,
                                  class: "ml-6 mr-6",
                                  color: "#C51162",
                                  icon: "mdi-cancel",
                                  theme: "dark",
                                  border: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("no-availability")), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_img, {
                            width: "150",
                            style: {"border-radius":"50%"},
                            src: doctor.value.photo
                          }, null, 8, ["src"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(GeneralInformation, {
                    isApplying: true,
                    startDate: startDate.value,
                    endDate: endDate.value,
                    hasAlreadyApplied: doctor.value.applied,
                    isDoctorAvailable: isDoctorAvailable.value,
                    doctorId: id.value
                  }, null, 8, ["startDate", "endDate", "hasAlreadyApplied", "isDoctorAvailable", "doctorId"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["cols"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(FooterComponent)
  ], 64))
}
}

})